import { GiBiceps } from "react-icons/gi";
import { useLeaderboard } from "../api/profile";
import { Loading } from "../pages/Loading";
import { ErrorView } from "../pages/ErrorView";
import { ElementRu } from "../types/army";
import { ElementEmblem } from "./ElementEmblem";
import { formatNumber } from "../lib/format";

interface Props {
  enabled: boolean;
}

export function LeaderboardView({ enabled }: Props) {
  const lb = useLeaderboard(enabled);

  if (lb.isPending) return <Loading message="Считаю рейтинг..." />;
  if (lb.isError) return <ErrorView message="Не получилось загрузить лидерборд." />;

  const rows = lb.data ?? [];
  return (
    <div className="space-y-2 px-3 pb-3">
      {rows.length === 0 ? (
        <div className="rounded-xl bg-tg-secondaryBg p-4 text-center text-sm text-tg-hint">
          Никого в рейтинге.
        </div>
      ) : (
        rows.map((r) => (
          <div
            key={r.id}
            className={`flex items-center gap-3 rounded-xl bg-tg-secondaryBg p-3 ${
              r.isSelf ? "border border-tg-accent" : ""
            }`}
          >
            <div className="w-7 text-center text-lg font-semibold tabular-nums text-tg-hint">
              {r.rank}
            </div>
            <ElementEmblem element={r.element} size={28} className="shrink-0" />
            <div className="min-w-0 flex-1">
              <div className="truncate font-medium">
                {r.name}
                {r.isSelf && <span className="ml-1 text-xs text-tg-accent">(ты)</span>}
              </div>
              <div className="text-xs text-tg-hint">{ElementRu[r.element]}</div>
            </div>
            <div className="text-right text-sm tabular-nums">
              <span className="inline-flex items-center gap-1"><GiBiceps size={12} /> {formatNumber(r.armyPower)}</span>
            </div>
          </div>
        ))
      )}
    </div>
  );
}

